<div class="flex flex-1">
  <dx-form
    [formData]="formData"
    class="flex-1"
    [colCount]="1 + groups.length"
    [readOnly]="readOnly"
    (onFieldDataChanged)="onFieldDataChanged($event)"
  >
    <dxi-item itemType="group" [colCount]="1">
      <dxi-item>
        <div *dxTemplate class="flex items-center justify-center">
          @if (!groups[0]) {
            <span>{{ " " }}</span>
          }
          @if (!!groups[0]) {
            <span>&nbsp;</span>
          }
        </div>
      </dxi-item>

      <dxi-item itemType="group" [colCount]="1">
        <dxi-item itemType="group" [colCount]="1">
          <dxi-item>
            <div *dxTemplate>
              <span class="font-medium text-slate-900">&nbsp;</span>
            </div>
          </dxi-item>

          @for (row of rows; track $index) {
            <dxi-item>
              <div *dxTemplate class="flex items-center">
                <span>{{ row | replace: "_" : " " | replace: "-" : "." }}</span>
              </div>
            </dxi-item>
          }
        </dxi-item>
      </dxi-item>
    </dxi-item>

    @for (group of groups; track $index) {
      <dxi-item
        itemType="group"
        [colCount]="1"
        cssClass="border-r-2 border-slate-100"
      >
        <dxi-item>
          <div *dxTemplate class="flex items-center justify-center">
            <span>{{ group | replace: "_" : " " | replace: "-" : "." }}</span>
          </div>
        </dxi-item>

        <dxi-item itemType="group" [colCount]="columns.length">
          @for (column of columns; track $index) {
            <dxi-item itemType="group" [colCount]="1">
              <dxi-item>
                <div *dxTemplate class="flex items-center justify-center">
                  <span class="font-medium text-slate-900">{{
                    column | replace: "_" : " " | replace: "-" : "."
                  }}</span>
                </div>
              </dxi-item>

              @for (row of rows; track $index) {
                <dxi-item
                  [dataField]="group + '-' + column + '-' + row"
                  editorType="dxCheckBox"
                  cssClass="flex items-center justify-center"
                  [label]="{ visible: false }"
                ></dxi-item>
              }
            </dxi-item>
          }
        </dxi-item>
      </dxi-item>
    }
  </dx-form>
</div>
